import { getFeatureFlagFromUrl } from '@/utils/featureFlags';

export function isPortalOutboundExportEnabled(): boolean {
  const urlOverride = getFeatureFlagFromUrl('portalOutboundExport');
  if (urlOverride !== null) return urlOverride;

  return import.meta.env.VITE_ENABLE_PORTAL_OUTBOUND_EXPORT === 'true';
}
